import React from 'react';
import { ArrowRightIcon, HandIcon, MoonIcon, ShieldCheckIcon, SunMediumIcon } from 'lucide-react';
import { useEnquiry } from '../../contexts/EnquiryContext';
const reasons = [{
  title: 'Security',
  description: 'Add another physical barrier across selected windows and openings when the shutters are closed.',
  icon: ShieldCheckIcon,
  priority: 'security' as const,
  number: '01'
}, {
  title: 'Harsh light & comfort',
  description: 'Create more control over strong afternoon light and how affected rooms feel during the day.',
  icon: SunMediumIcon,
  priority: 'comfort' as const,
  number: '02'
}, {
  title: 'Privacy & rest',
  description: 'Give exposed or light-sensitive rooms another layer of privacy and practical light control.',
  icon: MoonIcon,
  priority: 'light' as const,
  number: '03'
}, {
  title: 'Easier operation',
  description: 'Choose manual, powered or compatible smart controls around the people who will use them.',
  icon: HandIcon,
  priority: 'control' as const,
  number: '04'
}];
export function AnswerNeeds() {
  const {
    plannerAnswers,
    setPlannerAnswers
  } = useEnquiry();
  const chooseReason = (priority: typeof reasons[number]['priority']) => {
    setPlannerAnswers({
      ...plannerAnswers,
      priority
    });
    document.getElementById('options')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return <section id="why-shutters" className="scroll-mt-44 bg-neutral-canvas py-12 md:py-20" data-id="element-71" data-mp="2u9m6xfjr254n">
      <div className="mx-auto max-w-site px-5 lg:px-8" data-id="element-72" data-mp="3hzzogc4pklkz">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-73" data-mp="3mxi2ggxl1qzu">
          <div className="lg:sticky lg:top-44 lg:self-start" data-id="element-74" data-mp="3mwygmp4taigj">
            <p className="text-sm font-bold text-brand-charcoal/65" data-id="element-75" data-mp="387tzzcdo0maj">WHY ROLLER SHUTTERS?</p>
            <h2 className="mt-4 font-heading text-4xl font-extrabold leading-[1.03] tracking-[-0.035em] sm:text-5xl" data-id="element-76" data-mp="3d76jpo98pd8w">Four practical reasons. One measured solution.</h2>
            <p className="mt-6 max-w-xl text-lg leading-8 text-brand-charcoal/70" data-id="element-77" data-mp="9iv4jykug4dc">Start with the part of the home you want to change. MCF can work back from the outcome, the opening and the people who will use it.</p>
            <div className="mt-8 border-l-4 border-brand-yellow pl-5" data-id="element-78" data-mp="ef8zqcri26cb"><p className="font-bold" data-id="element-79" data-mp="egk5gi4i9o62">Not sure where to begin?</p><p className="mt-2 text-sm leading-6 text-brand-charcoal/70" data-id="element-80" data-mp="9fwefwga17bu">Choose the closest priority. It carries into the quote request and remains editable.</p></div>
          </div>
          <div className="border-t border-black/15" data-id="element-81" data-mp="fptjpi9152n">
            {reasons.map(reason => <button type="button" key={reason.title} onClick={() => chooseReason(reason.priority)} className="reason-choice group grid w-full grid-cols-[48px_1fr_28px] gap-4 border-b border-black/15 px-3 py-7 text-left transition-colors duration-150 hover:bg-brand-charcoal hover:text-white sm:grid-cols-[48px_48px_1fr_28px] sm:items-start sm:px-5 sm:py-8" data-id="element-82" data-mp="3rux6qu1p25dw">
                <span className="text-sm font-bold text-brand-charcoal/65 transition-colors duration-150 group-hover:text-white/70" data-id="element-83" data-mp="3du2vm3n9hqbj">{reason.number}</span>
                <reason.icon aria-hidden="true" className="hidden h-7 w-7 sm:block" strokeWidth={1.6} data-id="element-84" data-mp="1oea52p3edt3y" />
                <span data-id="element-85" data-mp="1tc26c9pxmrkt"><h3 className="font-heading text-2xl font-extrabold" data-id="element-86" data-mp="1tc22fymta7fj">{reason.title}</h3><span className="mt-2 block max-w-xl leading-7 text-brand-charcoal/70 transition-colors duration-150 group-hover:text-white/70" data-id="element-87" data-mp="1xeootk0pr05c">{reason.description}</span></span>
                <ArrowRightIcon aria-hidden="true" className="mt-1 h-5 w-5" data-id="element-88" data-mp="22b5p1cl6t4ys" />
              </button>)}
          </div>
        </div>
      </div>
    </section>;
}